import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FlexLayoutModule } from '@angular/flex-layout';
import { PKeyValueViewerComponent } from './p-key-value-viewer.component';

@NgModule({
    declarations: [PKeyValueViewerComponent],
    imports: [CommonModule, FlexLayoutModule],
    exports: [PKeyValueViewerComponent]
})
export class PKeyValueViewerModule {}
